{
  "fr": {
    "history": {
      "heading": {
        "title": "Mon historique"
      },
      "empty": {
        "noHistory": "Vous n'avez pas encore de commandes. Explorez les formations."
      },
      "links": {
        "allCourses": "Toutes les formations dans le catalogue"
      },
      "group": {
        "heading": {
          "title": "Groupes",
          "group": "Groupe",
          "access": "Accès",
          "link": "Lien",
          "actions": "Actions"
        },
        "links": {
          "goToGroup": "Vers le groupe",
          "myMaterial": "Mon matériel",
          "editMaterial": "Modifier le projet",
          "createMaterial": "Soumettre le projet",
          "downloadCertificate": "Télécharger le certificat",
          "adminArea": "Espace admin 🤓"
        }
      },
      "course": {
        "heading": {
          "title": "Mes formations",
          "course": "Formation",
          "access": "Accès",
          "certificate": "Certificat"
        },
        "links": {
          "downloadCertificate": "Télécharger le certificat"
        },
        "infos": {
          "missingProcess": "Pour obtenir le certificat, il manque :"
        }
      }
    }
  }
}
